module.exports = __webpack_public_path__ + "static/media/settings.df61f1b0.svg";